import em from './em';
import strong from './strong';
import underline from './underline';

export default { em, strong, underline };
